import { render } from "./ProjectsTab.vue?vue&type=template&id=2999803c&scoped=true"
import script from "./ProjectsTab.vue?vue&type=script&lang=js"
export * from "./ProjectsTab.vue?vue&type=script&lang=js"

import "./ProjectsTab.vue?vue&type=style&index=0&id=2999803c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2999803c"]])

export default __exports__